export const getLoadingPageLink = ():string => {
    return "/Loading"
}

export const getStartPage = ():string => {
    return "/"
}

export const getAuthPage = ():string => {
    return "/Authorize"
}

export const getDesktopPage = ():string => {
    return "/Desktop"
}